export default __webpack_public_path__ + "media/images/icon_email-297ed6231aa69425973d974b7d05b215.svg";